export default __webpack_public_path__ + "static/media/returns.7583a51d.svg";